"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.trackFlowCompleted = trackFlowCompleted;
exports.trackFlowStarted = trackFlowStarted;
exports.trackFlowStepCompleted = trackFlowStepCompleted;
exports.trackFlowStepSkipped = trackFlowStepSkipped;
exports.trackFlowStepViewed = trackFlowStepViewed;
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
var _trackingHelper = require("../trackingHelper");
var _flowTags = require("./flowTags");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
  This file contains events from the Zola Web Analytics tracking plan related to Flow:
  'Flow Started' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=913220254
  'Flow Completed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=670296566
  'Flow Step Viewed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1506255248
  'Flow Step Completed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1129828474
  'Flow Step Skipped' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=13127476

  These closely mimic the suite of onboarding events
*/

// Footer on LDP

/**
 * Common properties between flow events (started/completed) and flow step events
 * (completed/skipped).
 */

/**
 * Properties for tracking events related to the whole flow (Started/Completed).
 */

/**
 * Helper to make sure the flog tags we are passing into the tracking db are
 * in the allowed list of tags.  If our apps were all 100% typescript, we wouldn't
 * need this, but as soon as one place calls trackFlowStarted or trackFlowCompleted
 * in JavaScript with a tag that isn't allow, then we've polluted our tracking
 * database forever.
 */
var filterFlowPayload = function filterFlowPayload(payload) {
  return 'tags' in payload ? _objectSpread(_objectSpread({}, payload), {}, {
    tags: (0, _flowTags.filterFlowTags)(payload.tags)
  }) : payload;
};

/**
 * Fire when a multi-step action is started.  This
 *
 */
function trackFlowStarted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Started', filterFlowPayload(payload));
}
function trackFlowCompleted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Completed', filterFlowPayload(payload));
}

/**
 * The set of all properties sent to Segment
 */

/**
 * Indicates that the step in the flow has been completed.  The flow step completed
 * events let us know where in a multi-step flow the user drops off.
 *
 * Note: this method must be sent to ensure correct funnel analysis of user behavior
 */
function trackFlowStepCompleted(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Completed', payload);
}

/**
 * Note: this method is not used to analyze user drop-off. Be sure to send trackFlowStepCompleted
 *
 * @deprecated We are no longer using flow step viewed for analysis.
 */
function trackFlowStepViewed(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Viewed', payload);
}

/**
 * When an optional step in the flow is skipped instead of completed, fire this.
 */
function trackFlowStepSkipped(payload) {
  (0, _trackingHelper.trackEvent)('Flow Step Skipped', payload);
}
var _default = exports.default = {
  trackFlowCompleted: trackFlowCompleted,
  trackFlowStarted: trackFlowStarted,
  trackFlowStepCompleted: trackFlowStepCompleted,
  trackFlowStepSkipped: trackFlowStepSkipped,
  trackFlowStepViewed: trackFlowStepViewed
};